import { twMerge } from '@tuic/tailwind-config';

import { Icon } from '../../../core-components/Icon';
import { Skeleton } from '../../../core-components/Skeleton';

import type { IconName, IconProps } from '../../../core-components/Icon';
import type { FC, ReactNode } from 'react';

export type RowItem = {
  label: ReactNode;
  icon?: IconName;
  value?: ReactNode;
  fallback?: boolean;
  className?: string;
  iconSize?: IconProps['size'];
};

export const DataRow: FC<RowItem> = ({
  label,
  icon,
  value,
  fallback,
  className,
  iconSize,
}) => {
  if (fallback) {
    return <Skeleton className="my-2 h-8 w-full py-2" />;
  }

  return (
    <li
      className={twMerge(
        'flex flex-row justify-between border-b border-solid border-stroke-secondary-20 py-4 first:border-t',
        className,
      )}
    >
      <div className="flex flex-row items-center gap-2 text-marine-high-emphasis">
        {icon && (
          <Icon
            name={icon}
            className="text-marine-high-emphasis"
            size={iconSize ?? 'xs'}
          />
        )}
        <span>{value}</span>
      </div>
      <div className="text-marine-medium-emphasis">{label}</div>
    </li>
  );
};
